module.exports = function () {
    const searchButton = jQuery('#PageSearcher'),
        searchForm = jQuery('#searchform');

    // Hide on page load
    searchForm.slideUp(0);
    searchForm.removeClass('invisible');

    // Toggle on click
    searchButton.on('click', function () {
        searchForm.slideToggle(300);
    });

    // Hide on scroll
    jQuery(window).on('scroll', function () {
        searchForm.slideUp(300);
    });
}